import { api } from '@/lib/api'

export type LoginPayload = {
  email: string
  password: string
}

export type LoginResponse = {
  access_token: string
  token_type: string
  expires_in: number
}

export type RegisterPayload = {
  name: string
  email: string
  password: string
}

export type RegisterResponse = void

export type ForgotPasswordPayload = {
  email: string
}

export type ForgotPasswordResponse = void

export type ResetPasswordPayload = {
  token: string
  new_password: string
}

export type ResetPasswordResponse = void

export const loginService = (payload: LoginPayload): Promise<LoginResponse> =>
  api.post<LoginResponse>('/auth/login', payload).then((res) => res.data)

export const registerService = (payload: RegisterPayload): Promise<void> =>
  api.post('/auth/register', payload).then(() => undefined)

export const forgotPasswordService = (payload: ForgotPasswordPayload): Promise<void> =>
  api.post('/auth/forgot-password', payload).then(() => undefined)

export const resetPasswordService = (payload: ResetPasswordPayload): Promise<void> =>
  api.post('/auth/reset-password', payload).then(() => undefined)

export type GoogleLoginPayload = {
  id_token: string
}

export const googleLoginService = (payload: GoogleLoginPayload): Promise<LoginResponse> =>
  api.post<LoginResponse>('/auth/google', payload).then((res) => res.data)

export const confirmEmailService = (token: string): Promise<void> =>
  api.post('/auth/confirm-email', { token }).then(() => undefined)

export type User = {
  id: string
  name: string
  avatar_url: string | null
  email: string
  is_active: boolean
  created_at: string
}

export const getMeService = (): Promise<User> =>
  api.get<User>('/auth/me').then((res) => res.data)
